export default __webpack_public_path__ + "static/media/05.a80f78d1.png";